var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-list',{staticClass:"row no-wrap items-center"},_vm._l((_vm.menu),function(ref){
var label = ref.label;
var key = ref.key;
var to = ref.to;
return _c('q-item',{key:key,staticClass:"row items-center q-mr-md",attrs:{"clickable":"","dense":"","to":Object.assign({}, to,
      {query: Object.assign({}, (_vm.$route.query || {}),
        (to.query || {}))}),"active-class":"admin-menu-item-active"}},[_c('span',[_vm._v(_vm._s(label))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }